let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8yW2Y")).then(() => parcelRequire('S4yUH'));